import "./tournament-message-remove.scss";
import { useCallback, useEffect, useState } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import {
  faChevronLeft,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotifications,
  getMessage,
  deleteMessage,
  selectCurrentMessage,
  selectMessagesNotifications,
} from "../../../reducers/messagesSlice";
import { addNotification } from "../../../reducers/appSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  useNotificationAction,
  useNotificationBanner,
  useNotificationNavigation,
} from "../../../hooks/notificationHooks";
import { removeItemForm } from "../../../forms/DeleteForm";
import TournamentMessageCard from "./tournament-message-card";

const TournamentMessageRemove = () => {
  const [isValid, setIsValid] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const match = useMatch("/:tournamentID/messages/:messageID/remove");

  const currentMessage = useSelector(selectCurrentMessage);
  const notifications = useSelector(selectMessagesNotifications);

  useEffect(() => {
    dispatch(
      getMessage({
        tournamentID: match?.params?.tournamentID,
        messageID: match?.params?.messageID,
      }),
    );
  }, [dispatch, match?.params?.tournamentID, match?.params?.messageID]);

  const onMessageRemoved = useCallback(
    (notification) => {
      dispatch(addNotification(notification));
      dispatch(clearNotifications());
    },
    [dispatch],
  );

  useNotificationAction("removed", notifications, onMessageRemoved, "Message");

  useNotificationNavigation("removed", notifications, "../", "Message");

  const removeMessage = () => {
    setIsValid(false);
    dispatch(
      deleteMessage({
        messageID: match.params.messageID,
        tournamentID: match.params.tournamentID,
      }),
    );
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: "Delete Message",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getFormTitle = () => {
    return (
      <div className="delete-header">
        <div className="icon">
          <FontAwesomeIcon icon={faExclamationCircle} />
        </div>{" "}
        Delete Message
      </div>
    );
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getFormTitle()}
        formSections={removeItemForm(
          "this message",
          <TournamentMessageCard {...currentMessage} />,
        )}
      />
    );
  };

  const getDrawerActions = () => {
    return [
      {
        name: "Delete",
        isDisabled: !isValid,
        action: removeMessage,
        type: "red",
      },
      {
        name: "Cancel",
        action: leftNavigation,
        type: "grey",
      },
    ];
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    <tournament-message-remove>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-message-remove>
  );
};

export default TournamentMessageRemove;
